export default class ExtraBoard {
  label?: string;
  ordinal?: number;

  constructor(label: string, ordinal: number) {
    this.label = label;
    this.ordinal = ordinal;
  }
}

export const EXTRA_BOARD_CHOICES = {
  UNDER_BOARD: new ExtraBoard('Onderbord', 0),
  UPPER_BORD: new ExtraBoard('Bovenbord', 1)
};

export const EXTRA_BOARD_CHOICES_ARRAY = Object.values(EXTRA_BOARD_CHOICES);
